export const MEGA_PACK_CHECKOUT_URL = 'Link de checkout Mega Pack Tiroides'
export const MEGA_PACK_COCINA_CHECKOUT_URL =
  'Link de checkout Mega Pack + La Cocina sin Límites'

export const SCROLL_TARGET = 'comprar'

export interface Tomo {
  number: string
  title: string
  subtitle: string
  body: string
  closing: string
}

export const tomos: Tomo[] = [
  {
    number: 'TOMO 1',
    title: 'EL ESCUDO METABÓLICO',
    subtitle:
      'Para la mujer que quiere entender de una vez qué puede comer y qué conviene evitar, sin leer un manual de nutrición clínica.',
    body: '¿Cuáles son los alimentos que apoyan tu tiroides y cuáles la complican? ¿Qué son los bociógenos y por qué no hay que entrar en pánico con ellos? ¿Cuáles son los alimentos tramposos que parecen sanos y no lo son tanto? ¿Qué pasa con el gluten, la soja y el azúcar en la tiroides? ¿Por qué la interacción con tu medicación importa tanto?',
    closing:
      'El Tomo 1 tiene el Sistema Semáforo completo: luz verde, amarilla y roja, con el porqué biológico de cada alimento explicado en lenguaje humano, no clínico.',
  },
  {
    number: 'TOMO 2',
    title: 'INTELIGENCIA DE GÓNDOLA Y ETIQUETAS',
    subtitle: 'Para la mujer que va al supermercado y no sabe en qué confiar.',
    body: '¿Cómo leer una etiqueta en 30 segundos sin necesitar ser nutricionista? ¿Dónde se esconde el azúcar con nombres que no reconocés? ¿Cómo identificar el gluten disfrazado en productos que parecen seguros? ¿Qué marcas argentinas convienen y cuáles conviene evitar? ¿Cómo elegir una lata de caballa, un yogur o una salsa de tomate sin que te engañen?',
    closing:
      'El Tomo 2 te da el sistema para recorrer cada góndola del supermercado argentino con claridad y sin ansiedad.',
  },
  {
    number: 'TOMO 3',
    title: 'MÉTODO ECONOMÍA HORMONAL',
    subtitle:
      'Para la mujer que quiere comer bien sin que la inflación argentina arruine el plan.',
    body: '¿Cómo comprar los ingredientes más nutritivos al menor costo posible? ¿Qué conviene stockear en cantidad y qué conviene comprar fresco? ¿Cuáles son los sustitutos económicos de los ingredientes caros? ¿Cómo usar el freezer como herramienta antinflación? ¿Dónde comprar cada cosa en Argentina para pagar hasta un 50% menos?',
    closing:
      'El Tomo 3 tiene el sistema completo de compra inteligente para que comer bien para tu tiroides no sea un privilegio caro sino una estrategia económica accesible.',
  },
  {
    number: 'TOMO 4',
    title: 'CENAS MENTE EN OFF (15 MINUTOS)',
    subtitle:
      'Para la mujer que llega agotada a las 20:00 y necesita comer algo real sin pensar.',
    body: '¿Qué cocinás cuando no tenés energía para decidir qué cocinar? ¿Cómo armás una cena en 15 minutos con lo que hay en la heladera? ¿Qué recetas no requieren planificación previa? ¿Cómo hacer que la cena sea nutritiva aunque estés funcionando en piloto automático? ¿Qué tenés que tener siempre en la alacena para que ningún día quedes sin opciones?',
    closing:
      'El Tomo 4 tiene 20 recetas diseñadas para los días donde todo lo que tenés es cansancio y 15 minutos.',
  },
  {
    number: 'TOMO 5',
    title: 'EXPERIENCIA GOURMET (SABOR DE AUTOR)',
    subtitle:
      'Para la mujer que quiere sentir que come rico de verdad, no de dieta.',
    body: '¿Cómo hacer platos que parecen de restaurante con ingredientes del supermercado? ¿Qué técnicas de cocina simples transforman una proteína básica en un plato elegante? ¿Cómo recibir visitas sin cocinar dos versiones distintas? ¿Qué salsas y condimentos base te dan variedad infinita con pocos ingredientes? ¿Cómo hacer que comer para tu tiroides se sienta como un placer y no como una resignación?',
    closing:
      'El Tomo 5 tiene 13 recetas gourmet, 6 técnicas maestras y 5 salsas base que cambian cualquier plato.',
  },
  {
    number: 'TOMO 6',
    title: 'EL BODEGÓN SALUDABLE (CLÁSICOS ARGENTINOS)',
    subtitle:
      'Para la mujer que no quiere perder la milanesa, el guiso, la pizza y el pastel de papa.',
    body: '¿Cómo hacés milanesas sin gluten que queden igual de crocantes? ¿Podés seguir comiendo guiso, empanadas y pasta? ¿Cómo adaptás los platos de siempre sin que la familia se dé cuenta? ¿Qué cambia en la receta y qué no cambia? ¿Cómo hacés dulce de batata, alfajores y budín sin azúcar refinada?',
    closing:
      'El Tomo 6 tiene todas las versiones adaptadas de la cocina argentina clásica. La milanesa existe. El guiso existe. El asado existe. Solo cambia la manera de hacerlos.',
  },
  {
    number: 'TOMO 7',
    title: 'TIROIDES GREEN (ENERGÍA VEGETAL)',
    subtitle:
      'Para la mujer que quiere incorporar más días sin proteína animal o que elige comer 100% vegetal.',
    body: '¿Cómo cubrís el zinc, el hierro y el selenio sin carne? ¿Por qué hay que activar las legumbres y cómo hacerlo sin que sea un trabajo extra? ¿Qué reemplaza a la soja sin perder proteína? ¿Cómo combinás proteínas vegetales para que sean completas? ¿Cuáles son las 20 recetas veganas más nutritivas y accesibles para la tiroides?',
    closing:
      'El Tomo 7 tiene el sistema completo de alimentación plant-based para la tiroides, incluyendo protocolos de activación y combinaciones de proteína completa.',
  },
  {
    number: 'TOMO 8',
    title: 'LOGÍSTICA, SOS Y PLANIFICACIÓN',
    subtitle:
      'Para la mujer que sabe qué comer pero no sabe cómo sostenerlo en la vida real.',
    body: '¿Cómo organizás una semana de comidas en 30 minutos? ¿Qué es el Batch Cooking y cómo se hace en 1 hora para tener bases listas toda la semana? ¿Cómo organizás la heladera, el freezer y la alacena para que el sistema funcione solo? ¿Qué hacés cuando viajás, cuando tenés un evento o cuando la semana entera se desbordó? ¿Cómo registrás cómo te sentís para encontrar tus propios patrones?',
    closing:
      'El Tomo 8 tiene el sistema completo de ejecución semanal incluyendo planillas imprimibles, Batch Cooking, Guía SOS de Delivery y el Diario de Energía.',
  },
  {
    number: 'TOMO 9',
    title: 'RITUALES NOCTURNOS E INFUSIONES',
    subtitle:
      'Para la mujer que quiere cerrar el día de la manera más beneficiosa posible para su descanso.',
    body: '¿Qué tiene que ver el sueño con la función tiroidea? ¿Qué comés y qué evitás en las últimas 2 horas del día? ¿Qué infusiones apoyan el sueño, la digestión, el hígado y la inflamación? ¿Cómo hacés el Golden Milk, el chocolate tiroideo y las mezclas de hierbas específicas? ¿Cuál es el ritual de cierre nocturno completo para que tu tiroides trabaje bien mientras dormís?',
    closing:
      'El Tomo 9 tiene la guía completa de infusiones, bebidas calientes, postres nocturnos, mezclas de hierbas y el ritual de cierre del día.',
  },
]

export interface Bono {
  number: string
  title: string
  hook: string
  body: string
  closing: string
  image: string
}

export const bonos: Bono[] = [
  {
    number: 'BONO 1',
    title: 'EL SELECTOR TIROIDEO DE ALIMENTACIÓN PERSONAL',
    hook: 'Cuando no sabés por dónde empezar con 9 tomos disponibles.',
    body: 'Un test de perfil alimentario que te ubica en uno de los 6 estilos de la colección: alta proteína animal, pescetariano, vegetariano flexible, plant-based estratégico, económico argentino o cero energía/cero cocina. Al final del test sabés exactamente qué tomos leer primero, qué alimentos priorizar, qué lista de compras usar y cuál es tu primera receta de la semana.',
    closing:
      'Convierte una biblioteca de 9 tomos en un camino personalizado para tu vida.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/cce8beae-dbc2-415a-8ac5-0fa34adec8b3.jpg',
  },
  {
    number: 'BONO 2',
    title: 'LA ENCICLOPEDIA EXPRESS DE PROTEÍNAS TIROIDEAS',
    hook: 'Cuando no sabés qué proteína elegir hoy.',
    body: 'La guía completa de proteínas organizada por tipo de alimentación, tiempo disponible, presupuesto y objetivo del plato. Huevos, pollo, carne, pescados, latas, legumbres, semillas y frutos secos. Para cada una: cuándo conviene, cómo prepararla rápido, con qué combinarla y los errores que la mayoría comete. Incluye tabla de decisión rápida para imprimir y guardar en la heladera.',
    closing:
      'La respuesta a "¿y de proteína qué como hoy?" en menos de 30 segundos.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e149c738-e503-45cd-9adf-7ef5769d5da7.jpg',
  },
  {
    number: 'BONO 3',
    title: 'EL ATLAS DE PLATOS POR ESTADO DE ENERGÍA',
    hook: 'Cuando no sabés qué comer según cómo te sentís hoy.',
    body: '10 estados emocionales y físicos mapeados con opciones concretas para cada uno. Agotada. Con niebla mental. Pesada o hinchada. Con antojo dulce. Con antojo salado. Sin hambre pero sabiendo que necesitás comer. Queriendo algo reconfortante. Sin ganas de cocinar ni lavar nada. Queriendo sentir que comés rico de verdad. Fuera de casa sin cocina disponible. Para cada estado: opciones reales, tiempos reales y referencias exactas a recetas de la colección.',
    closing:
      'Porque no todos los días necesitás lo mismo y este atlas lo sabe.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/44e5bc9c-0bb8-4f39-918c-afecd0e5fda7.jpg',
  },
  {
    number: 'BONO 4',
    title: 'GUÍA PREMIUM DE COMPRAS POR TIPO DE DIETA',
    hook: 'Cuando no sabés exactamente qué comprar esta semana.',
    body: '8 listas de compra específicas según tu estilo de alimentación: carnívora alta proteína, pescetariana, vegetariana flexible, vegana estratégica, carnívora baja en harinas, económica argentina, familiar y cero cocina. Cada lista con sección de verdulería, proteínas, alacena, freezer y extras. Incluye guía de dónde comprar cada cosa en Argentina para pagar hasta un 50% menos, planilla mensual de compra mayor y lista de emergencia de bolsillo.',
    closing: 'La compra inteligente empieza antes de llegar al supermercado.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4718866f-9663-4af3-a851-c94e7f673990.jpg',
  },
  {
    number: 'BONO 5',
    title: 'EL MANUAL SOS DE VIDA REAL',
    hook: 'Cuando la vida interrumpe el sistema.',
    body: 'El protocolo completo para trabajo, kiosco, supermercado de paso, delivery por tipo de restaurante, cumpleaños, reuniones, viajes en avión, viajes en ruta, hoteles, días caóticos y semanas desbordadas. Incluye guía de delivery restaurante por restaurante con exactamente qué pedir y qué evitar en cada uno, scripts para eventos sociales sin tener que dar explicaciones, kit de viaje completo y protocolo de recuperación para cuando te saliste del plan sin culpa y sin ayuno compensatorio.',
    closing:
      'Para que el sistema funcione tanto en tu cocina como fuera de ella.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/267debb2-fbaa-4faa-ba07-8ed9a3700bbb.jpg',
  },
]

export interface Testimonio {
  quote: string
  name: string
  location: string
  age: number
}

export interface TestimonioAntesDespues {
  quote: string
  name: string
  location: string
  age: number
  image: string
  beforeLabel: string
  afterLabel: string
  before: string
  after: string
  note: string
}

export const testimonioAntesDespues: TestimonioAntesDespues = {
  quote:
    'No cambié mi vida de un día para el otro: empecé por tener opciones simples listas y dejar de decidir con hambre al final del día.',
  name: 'Julieta N.',
  location: 'Santa Fe',
  age: 43,
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/fb7fb058-b388-4455-9728-dcd24caae8ab.jpg',
  beforeLabel: 'Antes',
  afterLabel: 'Después',
  before:
    'Me miraba al espejo y sentía que no estaba pudiendo sostener una rutina que me hiciera bien.',
  after:
    'Empecé a organizar mis comidas de a poco y hoy me siento más constante, acompañada y conforme con mi proceso.',
  note: 'Experiencia personal. Cada proceso y cada necesidad alimentaria son distintos.',
}

// Testimonios originales del copy
export const testimoniosCopy: Testimonio[] = [
  {
    quote:
      'Llevaba tres años con el diagnóstico y nadie me había explicado de forma tan clara qué podía comer y qué no. El Sistema Semáforo del Tomo 1 me cambió la manera de comprar y de cocinar de golpe.',
    name: 'María Laura G.',
    location: 'Buenos Aires',
    age: 42,
  },
  {
    quote:
      'El Tomo 4 es el que más uso. Llego agotada del trabajo y en 15 minutos tengo una cena real. Ya no dependo del delivery ni termino comiendo cualquier cosa.',
    name: 'Claudia R.',
    location: 'Córdoba',
    age: 47,
  },
  {
    quote:
      'Por fin pude adaptar las milanesas y el guiso sin que mi familia se diera cuenta. El Tomo 6 resolvió el problema de cocinar doble que tenía hace meses.',
    name: 'Valeria T.',
    location: 'Rosario',
    age: 39,
  },
  {
    quote:
      'La guía de infusiones del Tomo 9 me transformó las noches. Duermo mejor y me levanto con más energía. No lo podía creer.',
    name: 'Daniela M.',
    location: 'Mendoza',
    age: 51,
  },
  {
    quote:
      'Compraba ingredientes con intención y terminaba tirándolos porque no sabía usarlos. Con el sistema de planificación del Tomo 8 eso se terminó. Por fin tengo una semana organizada.',
    name: 'Sofía P.',
    location: 'CABA',
    age: 36,
  },
]

// 5 testimonios adicionales que encajan con el avatar (mujeres con hipo/Hashimoto)
export const testimoniosExtra: Testimonio[] = [
  {
    quote:
      'Me diagnosticaron Hashimoto a los 44 y viví meses con miedo a comer cualquier cosa. Esta biblioteca me devolvió la tranquilidad. Ahora abro la heladera y sé qué hacer sin angustiarme.',
    name: 'Gabriela F.',
    location: 'La Plata',
    age: 44,
  },
  {
    quote:
      'Trabajo todo el día y llegaba a casa sin energía para pensar. Las cenas de 15 minutos del Tomo 4 y el Atlas por estado de energía me salvaron literalmente las noches de semana.',
    name: 'Silvina A.',
    location: 'Mar del Plata',
    age: 49,
  },
  {
    quote:
      'Siempre me sentí culpable pidiendo delivery. El Manual SOS me enseñó qué pedir en cada restaurante sin sabotearme. Comer afuera dejó de ser un problema.',
    name: 'Romina C.',
    location: 'San Miguel de Tucumán',
    age: 38,
  },
  {
    quote:
      'Con la inflación pensé que comer bien para la tiroides era imposible. El Método Economía Hormonal me demostró lo contrario. Compro más inteligente y gasto menos que antes.',
    name: 'Patricia L.',
    location: 'Neuquén',
    age: 55,
  },
  {
    quote:
      'Soy vegetariana y nunca encontraba información seria sobre tiroides sin carne. El Tomo 7 tiene todo: proteínas completas, activación de legumbres y recetas que de verdad me gustan.',
    name: 'Carolina B.',
    location: 'Salta',
    age: 41,
  },
]

export const includes: string[] = [
  'Los 9 tomos completos de la colección',
  'Más de 100 recetas listas para cocinar hoy',
  'Sistema Semáforo de alimentos completo',
  'Guía de lectura de etiquetas para supermercado argentino',
  'Sistema de compra inteligente con listas por perfil',
  'Batch Cooking y planificación semanal',
  'Guía completa de infusiones y rituales nocturnos',
  'Los 5 bonos especiales incluidos GRATIS',
  'Acceso digital inmediato y de por vida',
  'Imprimible desde tu casa en formato A4',
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Necesito saber cocinar para usar esto?',
    a: 'No. Las recetas están pensadas para personas reales con poco tiempo y poca energía. El Tomo 4 tiene 20 cenas de 15 minutos diseñadas específicamente para días donde no tenés ganas ni energía para cocinar.',
  },
  {
    q: '¿Los ingredientes se consiguen en Argentina?',
    a: 'Sí. Toda la colección fue desarrollada pensando en el supermercado, la verdulería y la dietética argentina. No hay ingredientes importados ni difíciles de conseguir. Si un ingrediente no está disponible en todos lados, la colección te da el reemplazo económico accesible.',
  },
  {
    q: '¿Sirve si soy vegetariana o vegana?',
    a: 'Sí. El Tomo 7 está dedicado exclusivamente a la alimentación plant-based para la tiroides con recetas, protocolos de activación de legumbres, combinaciones de proteína completa y listas de compras específicas. El Bono 4 incluye lista de compras vegana y vegetariana.',
  },
  {
    q: '¿Necesito consultar a un médico antes de usar esto?',
    a: 'La Biblioteca de la Tiroides Feliz es una guía alimentaria educativa e informativa. No reemplaza la consulta médica ni la indicación de tu endocrinólogo. Siempre seguí el tratamiento que tu médico te indicó. Esta colección complementa ese tratamiento dándote lo que el médico generalmente no tiene tiempo de darte: el sistema práctico de alimentación cotidiana.',
  },
  {
    q: '¿Qué pasa si ya tengo algunos tomos de la colección o información parecida?',
    a: 'Esta colección está integrada como sistema. Cada tomo conecta con los demás. Lo que hace única a la Biblioteca no es cada receta por separado sino la integración entre el conocimiento, las recetas, la organización, las compras y las herramientas para la vida real. Es probable que tengas información dispersa. Esta colección la organiza en un sistema completo y aplicable.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra recibís un email con el acceso a todos los archivos en formato PDF. Podés verlos en pantalla o imprimirlos desde tu casa. No hay envío físico ni espera.',
  },
  {
    q: '¿Sirve si tengo Hashimoto además de hipotiroidismo?',
    a: 'Sí. La colección fue desarrollada teniendo en cuenta el contexto autoinmune que implica el Hashimoto. El Tomo 1 aborda específicamente los alimentos que pueden impactar en la respuesta inflamatoria y el sistema inmune. Sin hacer promesas médicas, la información alimentaria está orientada a ese contexto específico.',
  },
  {
    q: '¿Puedo usar esto si acabo de recibir el diagnóstico?',
    a: 'Sí, y de hecho es uno de los mejores momentos para empezar. El Bono 1 (El Selector) está diseñado específicamente para orientar a personas que no saben por dónde empezar. Te ubica en tu perfil y te dice exactamente qué leer primero y cuáles son tus primeros pasos.',
  },
]

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/92b8b6ad-0f12-4ba7-ba6e-27df0df0ffc6.jpg'
